import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable({ providedIn: 'root' })
export class SidenavService {
  private sidenav!: MatSidenav;

  setSidenav(sidenav: MatSidenav): void {
    this.sidenav = sidenav;
  }

  async open(): Promise<void> {
    await this.sidenav.open();
  }

  async close(): Promise<void> {
    await this.sidenav.close();
  }

  async toggle(): Promise<void> {
    await this.sidenav.toggle();
  }
}
